import { XScale } from '../types';

export interface BarDimensions {
    widthFromScale: number;
    width: number;
    offset: number;
}

/**
 * Calculate bar/candle dimensions based on frequency and x-scale.
 * Shared utility to avoid duplicate calculations across renderers.
 */
export function calculateBarDimensions(
    xScale: XScale,
    frequencyMs: number
): BarDimensions {
    const domainStart = xScale.domain()[0];
    const widthFromScale = xScale(new Date(domainStart.getTime() + frequencyMs)) - xScale(domainStart);
    const width = Math.max(1, widthFromScale * 0.8);
    const offset = (widthFromScale - width) / 2;

    return { widthFromScale, width, offset };
}
